import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>PROFESSIONAL EXPERIENCE</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
            contentArrowStyle={{ borderRight: "7px solid  white" }}
            date="Jan 2025 – Present"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Moneyling</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Stamford, CT
            </h4>
            <h4>Senior Full Stack Developer</h4>
            <p>
              End-to-end software engineer with experience building scalable business platforms using Java, Next.js, TypeScript, AWS, and cloud-native technologies, improving operational efficiency, security, deployment reliability, and system observability while mentoring engineering teams and delivering client-focused solutions.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Mar 2019 – Dec 2024"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">DataKind</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Brooklyn, NY
            </h4>
            <h4>Full Stack Developer</h4>
            <p>
              Full-stack engineer who architected and delivered a high-performance PWA and scalable Java/Spring Boot platform, optimizing frontend performance, backend workflows, payment processing, security, and AWS deployments to support reliable, high-traffic transactional systems.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2017 - Feb 2019"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Tech Innovators of America
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Dublin, CA</h4>
            <h4>Software Engineer</h4>
            <p>
              Backend-focused software engineer with experience building Node.js services, REST APIs, database solutions, internal React dashboards, and ETL pipelines to support enterprise applications, analytics, and business intelligence reporting.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Apr 2013 - May 2017"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Midwestern State University
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Wichita Falls, TX
            </h4>
            <p>Bachelor of Science in Computer Science</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
